"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAdvancedOptionsValue = void 0;
require("../../core");
const getAdvancedOptionsValue = (filterValue) => {
    return Object.keys(filterValue)
        .map((key) => filterValue[key])
        .reduce((acc, val) => acc.concat(val), []);
};
exports.getAdvancedOptionsValue = getAdvancedOptionsValue;
//# sourceMappingURL=getAdvancedOptionsValue.js.map